/* eslint-disable */
const wrapperClassName = (state = '', action) => {
  switch (action.type) {
    case 'SET_WRAPPER_CLASS_NAME': {
      return action.value
  }
    default: {
      return state
    }
  }
}

export default wrapperClassName